<template>
  <div class="view-icons flex space-x-2">
    <div
      :class="[
        'w-6 h-6 flex justify-center items-center cursor-pointer icon',
        tileView === 'grid' ? 'active-icon' : '',
      ]"
      @click="changeTileView('grid')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
        />
      </svg>
    </div>
    <div
      :class="[
        'w-6 h-6 flex justify-center items-center cursor-pointer icon',
        tileView === 'list' ? 'active-icon' : '',
      ]"
      @click="changeTileView('list')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 10h16M4 14h16M4 18h16"
        />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TileViewIcons',
  props: {
    tileView: {
      type: String,
      required: true,
    },
    changeTileView: {
      type: Function,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.view-icons {
  .icon {
    border: 1px solid #dcdcea;
    border-radius: 2px;
  }
  svg {
    color: #dcdcea;
  }
  .active-icon {
    border-color: #6993ee;
    svg {
      color: #6993ee;
    }
  }
}
</style>